export default {
	message: {
		language: "English",
		fittingLogin: "Fitting系统专业版登录",
		loading: "载入中",
		scanToLogin: "请使用微信扫码登录/注册",
		switchLanguage: "切换语言",
		remainingDays: "剩余 {days} 天",
		    remainingTimes: "剩余 {times} 次",
		    newCustomer: "新建客户",
		    name: "姓名",
		    gender: "性别",
		    age: "年龄",
		    contact: "联系方式",
		    fitter: "Fitter",
		    date: "日期",
		    fittingRecords: "Fitting 记录",
		    editInfo: "编辑信息",
		    viewCreate: "查看/新建",
			 addCustomer: "新增客户",
			    editCustomer: "编辑客户",
				del:"删除客户",
			    name: "姓名",
			    gender: "性别",
			    male: "男",
			    female: "女",
			    age: "年龄",
			    contact: "联系方式",
			    fitter: "Fitter",
			    back: "返回",
			    save: "保存",
				fittingRecordss: "的Fitting记录",
				    backToCustomerList: "返回客户列表",
				    newFitting: "新建Fitting",
				    name: "姓名",
				    time: "时间",
				    status: "状态",
				    actions: "操作",
				    notProvided: "未填写",
				    downloadReport: "下载报告",
				    completeReport: "完成报告",
				    continueFitting: "继续Fitting"
	}
};